
import { Component, Prop, Vue } from "vue-property-decorator";
import {QrcodeStream} from "vue-qrcode-reader";
import VueQrcodeReader from "@/components/qrcode/scanners/VueQrcodeReader.vue";
import QrCodeStreamer from "@/components/QrCodeStreamer.vue";
import VueQrcodeReaderVanilla from "@/components/qrcode/scanners/VueQrcodeReaderVanilla.vue";
import VueBarcodeReader from "@/components/qrcode/scanners/VueBarcodeReader.vue";
import Html5Qrcode from "@/components/qrcode/scanners/Html5Qrcode.vue";
import zxing from "@/components/qrcode/scanners/ZXing.vue";
import { Getter } from "vuex-class";

@Component({
  components: {
    Html5Qrcode,
    VueBarcodeReader,
    QrCodeStreamer,
    VueQrcodeReader,
    VueQrcodeReaderVanilla,
    QrcodeStream,
    zxing,
  },
})

export default class QrCodeMultiScannerWrapper extends Vue {

    @Prop({default: null})
    public selectedComponent: string;

    @Prop({default: true})
    public hasForceInput: boolean;

    @Prop({default: false})
    public loading: boolean;

    @Prop({default: true})
    public displayReloadButton: boolean;

    @Getter private isMobile: boolean;

    private qrCodeString: string = null;
    private readerError: any = null;
    private readerResult: any = null;
    private displayScanner: boolean = true;

    get error() {
      if (this.readerError === "StreamApiNotSupportedError") {
        return this.$i18n.t("alerts.error.onlySafariSupported");
      }
      // return this.$i18n?.t(`alerts.error.${this.readerError}`); // Maybe ?
      return this.readerError;
    }

    private mounted(): void {
      // tslint:disable-next-line:no-console
      console.log("### mounted");
      this.qrCodeString = "";
      if (this.hasForceInput && !this.isMobile) {
        (this.$refs.fromUsbScanner as HTMLFormElement).focus();
      }
    }

    private onDecodeWrapper(decodedString: string): void {
      // tslint:disable-next-line:no-console
      console.log("### onDecodeWrapper : ", decodedString);
      this.readerResult = decodedString;
      this.$emit("decode", decodedString);
    }

    private displayError(error: string): void {
      // tslint:disable-next-line:no-console
      console.log("### displayError : ", error);
      this.readerError = error;
    }

    private forceReadQR(): void {
      // tslint:disable-next-line:no-console
      console.log("### forceReadQR");
      if (this.qrCodeString) {
        this.displayScanner = false;
        this.qrCodeString = this.qrCodeString.replace(/§/g, "-");
        this.$emit("decode", this.qrCodeString);
      }
    }

    private enterKeyPress(e: KeyboardEvent): void {
      // tslint:disable-next-line:no-console
      console.log("### enterKeyPress");
      if (e.keyCode === 13) {
        this.forceReadQR();
      }
    }

    private reloadScanner(): void {
      // tslint:disable-next-line:no-console
      console.log("### reloadScanner");
      this.displayScanner = false;
      this.readerError = null;
      this.readerResult = null;
      setTimeout(() => this.displayScanner = true, 500);
    }
}
